import {Form} from '@main/components/form/form';

/** Отправка формы аяксом. */
export class AjaxForm {
  /**
   * Конструктор класса.
   *
   * @param {HTMLFormElement} form Форма для отправки.
   *
   */
  constructor(form) {
    this.formElement = form;
    this.form = new Form(this.formElement);
    this.url = this.formElement.dataset.url;
    this.autoclose = this.formElement.dataset.autoclose;
    this.noTimeoutRedirect = this.formElement.dataset.noTimeoutRedirect;
    this.recaptchaInput = this.formElement.querySelector('.js-recaptcha-response');
    this.recaptchaKey = window.RECAPTCHA_KEY || '';
    this.bindEventListeners();
  }

  /**
   * Событие отправки формы.
   *
   * @returns {void}
   */
  bindEventListeners() {
    this.formElement.addEventListener('submit', (e) => {
      if (this.recaptchaInput && typeof grecaptcha !== 'undefined') {
        grecaptcha.ready(() => {
          grecaptcha.execute(this.recaptchaKey, {action: 'submit'}).then((token) => {
            this.recaptchaInput.value = token;
            this.submitForm(e);
          });
        });
      } else {
        this.submitForm(e);
      }
    });
  }

  /**
   * Отправка формы. В случае успеха/неуспеха - показать сообщение.
   *
   * @param {Event} e Событие, происходящее при отправке формы.
   * @returns {void}
   */
  async submitForm(e) {
    e.preventDefault();
    if (this.formElement.classList.contains('waiting') || !this.form.isValid) {
      return;
    }

    this.removeStatusClasses();

    this.id = this.formElement.dataset.id;
    const modal = this.formElement.closest('.js-modal');
    this.form.submitForm(e, modal);
    return false;
  }

  /**
   * Удалить классы статуса отправки.
   *
   * @returns {void}
   */
  removeStatusClasses() {
    this.formElement.classList.remove('success');
    this.formElement.classList.remove('error');
    this.formElement.classList.add('waiting');
  }
}

document.querySelectorAll('.js-ajax-form').forEach((el) => new AjaxForm(el));
